import {h, Fragment} from "preact"
import {FacetColorElement} from "./elements"

export default function FacetColorItem({facet, toggleProductFilter}) {
    return (
        <div class="ss__palette ss__palette--grid">
            {facet.data?.map(value => (
                <div
                    key={value.value}
                    class="ss__palette__option--container"
                    data-nosto-element="facet-setting"
                    role="menuitem"
                >
                    <FacetColorElement
                        value={value.value}
                        selected={value.selected}
                        onChange={e => {
                            e.preventDefault()
                            toggleProductFilter(facet.field, value.value, !value.selected)
                        }}
                    />
                </div>
            ))}
        </div>
    )
}